import { createAction, props } from '@ngrx/store';

const GET_CONSUMED_PROVIDER = '[Consumed Rest] Get consumed provider';
const SAVE_CONSUMED_PROVIDER_STATE = '[Consumed Rest] Save consumed provider state';
const SAVE_CONSUMED_COMPONENT_STATE = '[Consumed Rest] Save consumed component state';
const SAVE_CONSUMED_API_STATE = '[Consumed Rest] Save consumed api state';
const SAVE_CONSUMED_PROVIDER = '[Consumed Rest] Save Consumed provider';
const SET_CONSUMED_PROVIDER = '[Consumed Rest] Set Consumed provider';
const SET_CONSUMED_PROVIDER_TABLE = '[Consumed Rest] Set Consumed provider Table';
const DELETE_CONSUMED_PROVIDER = '[Consumed Rest] Delete Consumed provider';
const DELETE_CONSUMED_PROVIDER_STATE = '[Consumed Rest] Delete Consumed provider state';
const SET_DELETE_CONSUMED_PROVIDER = '[Consumed Rest] Set Delete Consumed provider';
const GET_CONSUMED_COMPONENT = '[Consumed Rest] Get consumed Functional Component';
const GET_CONSUMED_COMPONENT_PROVIDER_ID = '[Consumed Rest] Get consumed Component by Provider Id';
const SET_CONSUMED_COMPONENT_PROVIDER_ID = '[Consumed Rest] Set consumed Component by Provider Id';
const SAVE_CONSUMED_COMPONENT = '[Consumed Rest] Save Consumed Functional Component';
const SET_CONSUMED_COMPONENT = '[Consumed Rest] Set Consumed Functional Component';
const SET_CONSUMED_COMPONENT_TABLE = '[Consumed Rest] Set Consumed Functional Component Table';
const DELETE_CONSUMED_COMPONENT = '[Consumed Rest] Delete Consumed Functional Component';
const SET_DELETE_CONSUMED_COMPONENT = '[Consumed Rest] Set Delete Consumed Functional Component';
const GET_CONSUMED_API = '[Consumed Rest] Get consumed API';
const GET_CONSUMED_API_COMPONENT_ID = '[Consumed Rest] Get consumed API by component id';
const SET_CONSUMED_API_COMPONENT_ID = '[Consumed Rest] Set consumed API by component id';
const SAVE_CONSUMED_API = '[Consumed Rest] Save consumed API';
const SET_CONSUMED_API = '[Consumed Rest] Set consumed API';
const SET_NEW_CONSUMED_APIS = '[Consumed Rest] Set newly consumed APIs';
const DELETE_CONSUMED_API = '[Consumed Rest] Delete consumed API';
const SET_DELETE_CONSUMED_API = '[Consumed Rest] Set Delete consumed API';
const SAVE_CONSUMED_API_BATCH = '[Consumed Rest] Save consumed API batch';
const GET_CONSUMED_REST_ALL_DETAILS = '[Consumed Rest] Get all consumed rest details';
const GET_CONSUMED_API_PROVIDER_ID = '[Consumed Rest] get Api by ProviderId';
const SET_CONSUMED_API_PROVIDER_ID = '[Consumed Rest] set api by provider';
const GET_PROVIDER_AUTOSUGGEST = '[Consumed Rest] Get Provider Autosuggest';
const SET_PROVIDER_AUTOSUGGEST = '[Consumed Rest] Set Provider Autosuggest';
const GET_COMPONENT_AUTOSUGGEST = '[Consumed Rest] Get Component Autosuggest';
const SET_COMPONENT_AUTOSUGGEST = '[Consumed Rest] Set Component Autosuggest';
const GET_API_AUTOSUGGEST = '[Consumed Rest] Get API Autosuggest';
const SET_API_AUTOSUGGEST = '[Consumed Rest] Set API Autosuggest';
const GET_PROVIDER_ADVANCE_SEARCH = '[Consumed Rest] Get Provider  Advance Search';
const SET_PROVIDER_ADVANCE_SEARCH = '[Consumed Rest] Set Provider  Advance Search';
const GET_COMPONENT_ADVANCE_SEARCH = '[Consumed Rest] Get Component  Advance Search';
const SET_COMPONENT_ADVANCE_SEARCH = '[Consumed Rest] Set Component  Advance Search';
const GET_API_ADVANCE_SEARCH = '[Consumed Rest] Get API  Advance Search';
const SET_API_ADVANCE_SEARCH = '[Consumed Rest] Set API Advance Search';

const getConsumedProvider = createAction(GET_CONSUMED_PROVIDER, props<{ apiConstants: any }>());

const setConsumedProvider = createAction(SET_CONSUMED_PROVIDER, props<{ consumedProvider: any }>());

const setConsumedProviderTable = createAction(SET_CONSUMED_PROVIDER_TABLE, props<{ consumedProviderTable: any }>());

const saveConsumedProvider = createAction(
  SAVE_CONSUMED_PROVIDER,
  props<{ saveAPiConstants: any; consumedProviderData: any }>()
);

const saveConsumedProviderState = createAction(
  SAVE_CONSUMED_PROVIDER_STATE,
  props<{ success: boolean; consumedProvider: any }>()
);

const saveConsumedComponentState = createAction(
  SAVE_CONSUMED_COMPONENT_STATE,
  props<{ success: boolean; consumedComponent: any }>()
);

const saveConsumedApiBatchState = createAction(
  SAVE_CONSUMED_API_STATE,
  props<{ success: boolean; consumedApiBatch: any }>()
);

const deleteConsumedProvider = createAction(DELETE_CONSUMED_PROVIDER, props<{ deleteApiConstants: any; ids: any }>());

const deleteConsumedProviderState = createAction(
  DELETE_CONSUMED_PROVIDER_STATE,
  props<{ success: boolean; ids: any }>()
);

const getConsumedProviderAutoSuggest = createAction(GET_PROVIDER_AUTOSUGGEST, props<{ getApiConstants: any }>());

const setConsumedProviderAutosuggest = createAction(
  SET_PROVIDER_AUTOSUGGEST,
  props<{ providerAutosuggestResults: any }>()
);

const getConsumedProviderAdvanceSearch = createAction(GET_PROVIDER_ADVANCE_SEARCH, props<{ getApiConstants: any }>());

const setConsumedProviderAdvanceSearch = createAction(
  SET_PROVIDER_ADVANCE_SEARCH,
  props<{ providerAdvanceSearchtResults: any }>()
);

const getConsumedComponentAutoSuggest = createAction(GET_COMPONENT_AUTOSUGGEST, props<{ getApiConstants: any }>());

const setConsumedComponentAutosuggest = createAction(
  SET_COMPONENT_AUTOSUGGEST,
  props<{ componentAutosuggestResults: any }>()
);

const getConsumedComponentAdvanceSearch = createAction(GET_COMPONENT_ADVANCE_SEARCH, props<{ getApiConstants: any }>());

const setConsumedComponentAdvanceSearch = createAction(
  SET_COMPONENT_ADVANCE_SEARCH,
  props<{ componentAdvanceSearchRsults: any }>()
);

const getConsumedApiAutoSuggest = createAction(GET_API_AUTOSUGGEST, props<{ getApiConstants: any }>());

const setConsumedApiAutosuggest = createAction(SET_API_ADVANCE_SEARCH, props<{ apiAutosuggestResults: any }>());

const getConsumedApiAdvanceSearch = createAction(GET_API_ADVANCE_SEARCH, props<{ getApiConstants: any }>());

const setConsumedApiAdvanceSearch = createAction(SET_API_AUTOSUGGEST, props<{ apiAdvanceSearchResults: any }>());

const setDeleteConsumedProvider = createAction(SET_DELETE_CONSUMED_PROVIDER, props<{ deletedProvider: boolean }>());

const getConsumedComponent = createAction(GET_CONSUMED_COMPONENT, props<{ apiConstants: any; appId: any }>());

const saveConsumedComponent = createAction(
  SAVE_CONSUMED_COMPONENT,
  props<{ saveAPiConstants: any; consumedComponentData: any }>()
);

const setConsumedComponentTable = createAction(SET_CONSUMED_COMPONENT_TABLE, props<{ consumedComponentTable: any }>());

const setConsumedComponent = createAction(SET_CONSUMED_COMPONENT, props<{ consumedComponent: any }>());

const deleteConsumedComponent = createAction(DELETE_CONSUMED_COMPONENT, props<{ deleteApiConstants: any; ids: any }>());

const setDeleteConsumedComponent = createAction(
  SET_DELETE_CONSUMED_COMPONENT,
  props<{ deletedComponent: any }>()
);

const getConsumedApi = createAction(GET_CONSUMED_API, props<{ apiConstants: any; appId: any }>());

const getConsumedComponentByProviderId = createAction(
  GET_CONSUMED_COMPONENT_PROVIDER_ID,
  props<{ getConsumedComponentByProviderIdApi: any; params: any }>()
);

const setComponentByProviderId = createAction(
  SET_CONSUMED_COMPONENT_PROVIDER_ID,
  props<{ consumedComponentByProvider: any }>()
);

const getConsumedAPIByComponentId = createAction(
  GET_CONSUMED_API_COMPONENT_ID,
  props<{ getConsumedAPIByComponentIdApi: any; params: any }>()
);

const getConsumedAPIByProviderId = createAction(
  GET_CONSUMED_API_PROVIDER_ID,
  props<{ apiConstants: any; params: any }>()
);

const setAPIByComponentId = createAction(
  SET_CONSUMED_API_COMPONENT_ID,
  props<{ componentId: any; consumedAPIByComponent: any }>()
);

const setAPIByProviderId = createAction(
  SET_CONSUMED_API_PROVIDER_ID,
  props<{ providerId: any; consumedAPIByProvider: any }>()
);

const saveConsumedApi = createAction(SAVE_CONSUMED_API, props<{ saveAPiConstants: any; consumedApiData: any }>());

const saveConsumedApiBatch = createAction(
  SAVE_CONSUMED_API_BATCH,
  props<{ saveAPiConstants: any; consumedApiDataBatch: any }>()
);

const setConsumedApi = createAction(SET_CONSUMED_API, props<{ consumedApi: any }>());

const setNewlyConsumedApis = createAction(SET_NEW_CONSUMED_APIS, props<{ newlyConsumedApiTable: any }>());

const deleteConsumedApi = createAction(DELETE_CONSUMED_API, props<{ deleteApiConstants: any; ids: any }>());

const setDeleteConsumedApi = createAction(SET_DELETE_CONSUMED_API, props<{ deletedApi: any }>());

const getConsumedRestAllDetails = createAction(GET_CONSUMED_REST_ALL_DETAILS, props<{ apiConstants: any }>());

export {
  getConsumedProvider,
  saveConsumedProvider,
  setConsumedProvider,
  setConsumedProviderTable,
  saveConsumedProviderState,
  deleteConsumedProvider,
  deleteConsumedProviderState,
  getConsumedComponent,
  saveConsumedComponent,
  setConsumedComponent,
  setConsumedComponentTable,
  deleteConsumedComponent,
  getConsumedApi,
  saveConsumedApi,
  setConsumedApi,
  deleteConsumedApi,
  saveConsumedApiBatch,
  getConsumedAPIByComponentId,
  getConsumedComponentByProviderId,
  setComponentByProviderId,
  setAPIByComponentId,
  setNewlyConsumedApis,
  setDeleteConsumedProvider,
  setDeleteConsumedComponent,
  setDeleteConsumedApi,
  getConsumedRestAllDetails,
  getConsumedAPIByProviderId,
  setAPIByProviderId,
  getConsumedComponentAutoSuggest,
  setConsumedComponentAutosuggest,
  getConsumedApiAutoSuggest,
  setConsumedApiAutosuggest,
  getConsumedProviderAutoSuggest,
  setConsumedProviderAutosuggest,
  getConsumedComponentAdvanceSearch,
  setConsumedComponentAdvanceSearch,
  getConsumedApiAdvanceSearch,
  setConsumedApiAdvanceSearch,
  getConsumedProviderAdvanceSearch,
  setConsumedProviderAdvanceSearch,
  saveConsumedComponentState,
  saveConsumedApiBatchState
};
